<template>
  <div class="index-container">
    <el-row>
      <el-col :xs="24" class="index-nav">
        <todo-logo class="index-logo">
          {{ $t('site.slogan') }}
        </todo-logo>

        <div class="index-button">
          <router-link to="/logout" tag="button" class="el-button el-button--warning is-circle">
            <svg-icon name="arrow-right" color="#141414" :fill="false" />
          </router-link>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import '../icons/components'

  export default {}
</script>

<style lang="scss">
  @import '../assets/variables';

  .index-container {
    z-index: 1;
    position: relative;
    height: 100%;
    background-color: #2E56E2;

    .el-row {
      height: 100%;

      .el-col {
        height: 100%;
      }
    }

    .index-nav {
      position: relative;
      max-width: 455px;
      background-image: url("~@/img/bg-nav-full.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }

    .index-logo {
      position: absolute;
      width: 240px;
      height: 150px;
      margin: auto;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      color: white;

      .logo {
        font-size: 40px;
        line-height: 58px;
      }

      p {
        font-size: 16px;
        line-height: 24px;
        margin-top: 15px;
      }
    }

    .index-button {
      position: absolute;
      bottom: 45px;
      right: 70px;
    }
  }
</style>
